import { Card, CardContent } from '../ui/card';
import { Kpis } from '../../types/campaignReport';
import { formatCurrencyGBP, formatNumberCompact } from '../../lib/reportFormatters';
import { Users, Eye, MousePointerClick, ShoppingBag, Package, TrendingUp } from 'lucide-react';

interface KpiGridProps {
  kpis: Kpis;
}

export function KpiGrid({ kpis }: KpiGridProps) {
  const kpiCards = [
    {
      title: 'Footfall',
      value: kpis.footfall.sixMonthTotal,
      formatter: formatNumberCompact,
      helper: kpis.footfall.monthlyAverage 
        ? `Avg: ${formatNumberCompact(kpis.footfall.monthlyAverage)}/mo`
        : '6-month total',
      icon: Users,
      color: '#183df7',
    },
    {
      title: 'Screen Impressions',
      value: kpis.screenImpressions.sixMonthTotal,
      formatter: formatNumberCompact,
      helper: kpis.screenImpressions.monthlyAverage
        ? `Avg: ${formatNumberCompact(kpis.screenImpressions.monthlyAverage)}/mo`
        : '6-month total',
      icon: Eye,
      color: '#183df7',
    },
    {
      title: 'Interactions',
      value: kpis.interactions.sixMonthTotal,
      formatter: formatNumberCompact,
      helper: kpis.interactions.monthlyAverage
        ? `Avg: ${formatNumberCompact(kpis.interactions.monthlyAverage)}/mo`
        : '6-month total',
      icon: MousePointerClick,
      color: '#183df7',
    },
    {
      title: 'Browsing Sessions',
      value: kpis.browsingSessions.sixMonthTotal,
      formatter: formatNumberCompact,
      helper: kpis.browsingSessions.monthlyAverage
        ? `Avg: ${formatNumberCompact(kpis.browsingSessions.monthlyAverage)}/mo`
        : '6-month total',
      icon: ShoppingBag,
      color: '#183df7',
    },
    {
      title: 'Total Units Sold',
      value: kpis.totalUnitsSold,
      formatter: formatNumberCompact,
      helper: '6-month total',
      icon: Package,
      color: '#183df7',
    },
    {
      title: 'Total Campaign Revenue',
      value: kpis.totalCampaignRevenue,
      formatter: formatCurrencyGBP,
      helper: '6-month total',
      icon: TrendingUp,
      color: '#183df7',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {kpiCards.map((kpi, index) => {
        const Icon = kpi.icon;
        return (
          <Card
            key={index}
            style={{
              boxShadow: '0 4px 6px -1px rgba(24, 61, 247, 0.3), 0 2px 4px -1px rgba(24, 61, 247, 0.18)',
            }}
          >
            <CardContent className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-muted-foreground mb-1">{kpi.title}</p>
                  <p className="text-3xl md:text-4xl font-bold" style={{ color: kpi.color }}>
                    {kpi.formatter(kpi.value)}
                  </p>
                </div>
                <Icon className="w-8 h-8 opacity-20" style={{ color: kpi.color }} />
              </div>
              <p className="text-xs text-muted-foreground">{kpi.helper}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
